import { useState, useEffect } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Loader2, Mail } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "../ui/dialog";
import { Button } from "../ui/button";
import { Input } from "../ui/input";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const useExitIntent = (pageId) => {
  const [open, setOpen] = useState(false);
  const key = `exit-intent-${pageId}`;
  const trigger = () => {
    if (sessionStorage.getItem(key)) return false;
    sessionStorage.setItem(key, "1");
    setOpen(true);
    return true;
  };
  useEffect(() => {
    const onLeave = (e) => { if (e.clientY <= 0 && !e.relatedTarget) trigger(); };
    document.addEventListener("mouseout", onLeave);
    return () => document.removeEventListener("mouseout", onLeave);
  }, [pageId]);
  return { open, setOpen, trigger };
};

export const ExitIntentDialog = ({ open, pageId, percent, onPublish, onClose }) => {
  const [email, setEmail] = useState("");
  const [sending, setSending] = useState(false);
  const send = async (e) => {
    e.preventDefault();
    setSending(true);
    try {
      await axios.post(`${API}/pages/${pageId}/save-link`, { email });
      toast.success("Link verschickt – Ihre Vorschau ist gespeichert.");
      onClose();
    } catch (err) {
      toast.error(err.response?.data?.detail || "Versand fehlgeschlagen. Bitte erneut versuchen.");
    } finally {
      setSending(false);
    }
  };
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="sm:max-w-md" data-testid="exit-intent-dialog">
        <DialogHeader>
          <DialogTitle>Ihre Seite ist schon zu {percent} % fertig</DialogTitle>
          <DialogDescription>Nur noch Domain wählen und veröffentlichen. Keine Zeit gerade? Wir schicken Ihnen den Link zu Ihrer Vorschau.</DialogDescription>
        </DialogHeader>
        <Button onClick={onPublish} className="h-11 w-full rounded-full bg-indigo-600 hover:bg-indigo-700" data-testid="exit-publish-btn">Jetzt veröffentlichen</Button>
        <form onSubmit={send} className="flex gap-2">
          <Input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="ihre@email.de" data-testid="exit-email-input" />
          <Button type="submit" variant="outline" disabled={sending} data-testid="exit-send-link-btn">
            {sending ? <Loader2 className="h-4 w-4 animate-spin" /> : <Mail className="h-4 w-4" />}
            <span className="ml-1.5">Link senden</span>
          </Button>
        </form>
        <p className="text-xs text-slate-400">Wir nutzen Ihre E-Mail nur, um Ihnen diesen Link zu schicken.</p>
      </DialogContent>
    </Dialog>
  );
};
